import React, { useState, useEffect, useRef } from "react";
import { TextInput } from "../forms";
import {
  _getBaseUrl,
} from "../utils/helper";

const MultiSelectDropdown = ({ options, selected, setSelected, classes, searchable }) => {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleOption = (value) => {
    if (selected.includes(value)) {
      setSelected(selected.filter((val) => val !== value));
    } else {
      setSelected([...selected, value]);
    }
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className={`w-full border p-4 rounded appearance-none text-left ${classes || ""}`}
      >
        {selected.length > 0
          ? `${selected.length} geselecteerd`
          : "Selecteren"}
      </button>

      {open && (
        <div className="absolute z-10 bg-white border shadow-md mt-1 w-full rounded p-4 pt-0 max-h-60 overflow-y-auto">

          { searchable &&
            <div className="sticky bg-white z-20 top-0 left-0 w-full h-20 py-4">
              <TextInput
                name="search-tag"
                label="Nieuwe tag toevoegen"
                placeholder="Typ om te zoeken"
                onChange={(value) => {
                  setSearchTerm(value.trim());
                }}
                value={searchTerm}
                marginCss=""
                hideLabel={true}
              />

              <img
                src={_getBaseUrl("src/assets/inspiratiepunten/remove.svg", true)}
                alt="Verwijder"
                className="w-4 h-4 absolute top-1/2 -translate-y-1/2 right-4 cursor-pointer"
                onClick={() => setSearchTerm("")}
              />
            </div>
          }

          {options
            .filter(opt => opt.label.toLowerCase().includes(searchTerm.toLowerCase()))
            .map((opt) => (
            <label key={opt.value} className="flex items-center space-x-2 py-1">
              <input
                type="checkbox"
                value={opt.value}
                checked={selected.includes(opt.value)}
                onChange={() => toggleOption(opt.value)}
              />
              <span>{opt.label}</span>
            </label>
          ))}

        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
